<template>
    <Banner :isLogin="ifUser()" />
    <Main :isLogin="ifUser()" />
</template>
<script setup>
import Banner from '@c/index/Banner.vue'
import Main from '@c/index/Main.vue'
import { getUserToken } from "@u/helpers/auth"

const ifUser = () => !!getUserToken()

const browserGo = () => {
  location.pathname === '/' && window.history.go(-1)
}

onMounted(() => {
  // 监听浏览器返回
  window.addEventListener('popstate', browserGo, false)
});

onUnmounted(() => {
  window.removeEventListener('popstate', browserGo, false)
})
</script>
